<template>
  <modal
    class="editProduct"
    name="editProduct"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    :opened="opened"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.editProductModal.title") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.editProductModal.productName") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$t('text.editProductModal.productName')"
                    v-model="product.productName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.editProductModal.price") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$t('text.editProductModal.price')"
                    v-model="product.price"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.editProductModal.state") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    v-model="state.name"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div>
              <p
                style="margin-top: 30px; margin-bottom: -5px; font-size: 18px"
                class="primary_text"
              >
                {{ $t("text.editProductModal.localGov") }}
                {{
                  (product && product.deliverableLGAs.length > 1) ||
                  (product && product.deliverableLGAs.length === 0)
                    ? $tc("text.editProductModal.area", 2)
                    : $tc("text.editProductModal.area", 1)
                }}
              </p>
            </div>
            <div
              class="row"
              v-for="(prod, index) in product.deliverableLGAs"
              :key="index"
            >
              <div class="col-md-5">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.editProductModal.lgaName") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <select v-model="prod.lgaId">
                      <option :value="lg.id" v-for="(lg, i) in lgas" :key="i">
                        {{ lg.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.editProductModal.deliveryHour") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="number"
                      :placeholder="$t('text.editProductModal.deliveryHour')"
                      v-model="prod.deliveryHour"
                    />
                  </div>
                </div>
              </div>
              <div
                class="block_6 col-md-2 delete_LGA"
                v-if="product.deliverableLGAs.length > 1"
              >
                <img
                  src="@/assets/img/remove (1).png"
                  style="float: right; cursor: pointer"
                  @click="deleteLGA(index)"
                />
              </div>
            </div>

            <div class="mt-3 pb-3">
              <button
                class="add_more_btn"
                @click="
                  addLocalGovernment($event, product.deliverableLGAs, index)
                "
              >
                {{ $t("text.editProductModal.addMore") }}
              </button>
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="editProduct($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.editProductModal.title") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "modalProduct",
  props: ["modalProduct", "states", "state"],
  data() {
    return {
      product: "",
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      // stateId: "",
      lgas: [],
    };
  },
  computed: {
    stateId: {
      get: function () {
        return this.state;
      },
    },
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
    // this.getStateLga();
  },
  mounted() {
    // this.getStateLga();
  },
  watch: {
    state: function () {
      this.getStateLga();
    },
    modalProduct: {
      immediate: true,
      handler() {
        this.product = this.modalProduct;
      },
    },
  },
  methods: {
    addLocalGovernment($event) {
      $event.preventDefault();
      this.product.deliverableLGAs.push({});
    },
    deleteLGA(index) {
      this.product.deliverableLGAs.splice(index, 1);
    },
    opened() {
      this.getStateLga();
    },
    getStateLga() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/LGA/${this.state.id}`,
          configObject.authConfig()
        )
        .then((resp) => {
          this.lgas = resp.data;
        });
    },
    stateChanged(event, index) {
      this.stateId = event.target.value;
      this.getStateLga(this.stateId);
    },
    closeEditProductModal() {
      this.$modal.hide("editProduct");
    },
    editProduct($event) {
      $event.preventDefault();
      if (!this.product.productName) {
        this.$toast.open({
          message: this.$t("text.editProductModal.productNameMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.product.price) {
        this.$toast.open({
          message: this.$t("text.editProductModal.priceMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (this.product.price <= 0) {
        this.$toast.open({
          message: this.$t("text.errors.invalidPrice"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      for (var x of this.product.deliverableLGAs) {
        let leave = false;
        if (!x.deliveryHour) {
          this.$toast.open({
            message: this.$t("text.editProductModal.deliveryHourMissing"),
            type: "error",
            duration: 5000,
          });
          this.formIsValid = false;
          return;
        }
        if (x.deliveryHour < 1) {
          this.$toast.open({
            message: this.$t("text.addProduct.invalidDeliveryHour"),
            type: "error",
            duration: 3000,
          });
          return;
        }
        x.deliveryHour = parseInt(x.deliveryHour);
      }
      this.product.deliverableLGAs = this.product.deliverableLGAs.map(
        (cur) => ({
          deliveryHours: cur.deliveryHour,
          lgaId: cur.lgaId,
        })
      );
      let companyId;
      if (localStorage.getItem("companyDetails") !== null) {
        companyId = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      this.product.price = parseInt(this.product.price);

      let data = {
        id: this.product.id,
        productId: this.product.productId,
        productName: this.product.productName,
        price: this.product.price,
        stateId: this.state.id,
        lgAs: this.product.deliverableLGAs,
        companyId,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Delivery/Product`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeEditProductModal();
          this.$toast.open({
            message: this.$t("text.editProductModal.successfullyEdited"),
            type: "success",
            duration: 5000,
          });
          this.$eventHub.$emit("getProducts");
          data = null;
          this.lgas = [];
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.closeEditProductModal();
          $(".loader").hide();
        });
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  h3.zone_header_text {
    font-size: 19px;
    margin-top: 21px;
  }
}
</style>
